import React from 'react';
import { NamedLink } from '../../../../components';

export default [
    {
        heading: <h3>Was kostet HorseDeal?</h3>,
        description: (
            <>
                <p>
                    HorseDeal kannst Du völlig unverbindlich nutzen. Das Erstellen eines Reiter-
                    oder Pferde-Profils sowie das Versenden von Anfragen ist für alle Mitglieder
                    dauerhaft kostenlos.
                </p>
                <p>
                    Damit echte Matches entstehen können, nutzen wir ein Credit-System: Wenn Du eine
                    Anfrage von einem anderen Mitglied erhältst, kannst Du vor der Annahme das
                    gesamte Profil sowie die Übereinstimmung auf Basis unseres Matchings vollständig
                    einsehen. Erst für die Annahme der Anfrage werden Credits benötigt.
                </p>

                <p>
                    Zum Start erhältst Du kostenlose Credits, mit denen Du alle Funktionen
                    risikofrei ausprobieren kannst. Auch später musst Du keine Credits kaufen - Du
                    kannst sie dir jederzeit durch Aktionen wie{' '}
                    <NamedLink name="ReferralPage">Freunde einladen</NamedLink> oder unser{' '}
                    <NamedLink name="FlipAndWin">Flip & Win</NamedLink> kostenlos sichern.
                </p>
                <p>
                    Darüber hinaus stehen dir Premium-Funktionen zur Verfügung, mit denen Du noch
                    leichter neue Pferdemenschen oder Pferde in deiner Nähe findest, dein Profil
                    individueller gestalten kannst und mehr Sichtbarkeit erhältst. Eine Übersicht
                    aller verfügbaren Pakete findest Du auf unserer Seite{' '}
                    <NamedLink name="PricingPage">Preisgestaltung</NamedLink>.
                </p>
            </>
        ),
    },
    {
        heading: <h3>Wo kann ich meine Credits einsehen?</h3>,
        description: (
            <p>
                Einen Überblick über deine gesammelten, erworbenen sowie ausgegebenen Credits
                erhältst Du auf der Seite Bilanz. Melde dich in deinem Konto an und klicke in der
                Navigation anschliessend auf „Meine Bilanz“.
            </p>
        ),
    },
    {
        heading: <h3>Wofür werden Credits genau benötigt?</h3>,
        description: (
            <p>
                Credits benötigst Du, um Anfragen anderer Mitglieder zu akzeptieren und so ein Match
                herzustellen. Bevor Du dich entscheidest, kannst Du das komplette Profil sowie die
                Übereinstimmung auf Basis unseres Matchings einsehen. Erst wenn Du die Anfrage
                annimmst, werden Credits eingesetzt. Das Erstellen eines Reiter- oder Pferde-Profils
                sowie das Versenden von Anfragen ist für alle Mitglieder dauerhaft kostenlos.
            </p>
        ),
    },
    {
        heading: <h3>Verfallen meine Credits irgendwann?</h3>,
        description: (
            <p>
                Nein, deine Credits haben kein Ablaufdatum. Einmal erworbene oder erhaltene Credits
                bleiben dauerhaft in deinem Konto gespeichert und können jederzeit genutzt werden.
            </p>
        ),
    },
    {
        heading: <h3>Welche Zahlungsmethoden gibt es?</h3>,
        description: (
            <p>
                Du kannst Credits bequem mit allen gängigen Zahlungsmethoden bezahlen. Dazu gehören
                Kreditkarten (Visa, Mastercard), Twint, Apple Pay, Google Pay sowie Zahlung auf
                Rechnung mit Klarna. Je nach Land können weitere Optionen zur Verfügung stehen.
            </p>
        ),
    },
    {
        heading: <h3>Wie kann ich kostenlose Credits erhalten?</h3>,
        description: (
            <p>
                Wenn Du dich als neues Mitglied bei HorseDeal registrierst, erhältst Du kostenlose
                Credits, mit denen Du alle Funktionen risikofrei ausprobieren kannst. Auch später
                musst Du keine Credits kaufen - Du kannst sie dir jederzeit durch Aktionen wie{' '}
                <NamedLink name="ReferralPage">Freunde einladen</NamedLink> oder unser{' '}
                <NamedLink name="FlipAndWin">Flip & Win</NamedLink> kostenlos sichern.
            </p>
        ),
    },
    {
        heading: <h3>Was sind Anfragen?</h3>,
        description: (
            <p>
                Anfragen sind Kontaktaufnahmen zwischen Reiter:innen und Pferdebesitzer:innen auf
                HorseDeal. Du kannst anderen Mitgliedern eine Anfrage senden, wenn dich ihr Profil
                interessiert. Wenn Du selbst eine Anfrage erhältst, kannst Du vor der Annahme das
                gesamte Profil sowie die Übereinstimmung auf Basis unseres Matchings einsehen. Erst
                mit deiner Annahme entsteht ein Match und ihr könnt direkt miteinander
                kommunizieren. In unserem Helpcenter zeigen wir dir Schritt für Schritt, wie Du
                Anfragen akzeptieren kannst. Besuche dazu{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/18591325417106"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    diesen Artikel
                </a>
                .
            </p>
        ),
    },
    {
        heading: <h3>Was sind Ansichten?</h3>,
        description: (
            <p>
                Ansichten zeigen dir, wie oft dein Reiter- oder Pferde-Profil von anderen
                Mitgliedern aufgerufen wurde. Dabei siehst Du nicht nur die Anzahl, sondern auch
                genau, wer dein Profil besucht hat. Profile, die das Zusatzpaket „Privates Profil“
                nutzen, werden in der Ansicht allerdings nicht aufgeführt. So erhältst Du einen
                transparenten Überblick darüber, wie sichtbar dein Profil ist und welches Interesse
                es in der Community weckt. In unserem Helpcenter zeigen wir dir Schritt für Schritt,
                wie Du Ansichten aufdecken kannst. Besuche dazu{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/21138727380114"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    diesen Artikel
                </a>
                .
            </p>
        ),
    },
    {
        heading: <h3>Was ist ein „Geschenktes Match“?</h3>,
        description: (
            <p>
                Die Funktion „Geschenktes Match“ ermöglicht es dir, einem anderen Mitglied
                30 Credits zu schenken, damit es deine Anfrage kostenlos akzeptieren kann - so
                steigerst Du deine Chancen auf ein Match! Wenn die Anfrage nicht angenommen wird
                oder nach 14 Tagen abläuft, erhältst Du deine Credits automatisch zurück. In unserem
                Helpcenter zeigen wir dir Schritt für Schritt wie Du die Funktion aktivieren kannst.
                Besuche dazu{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/23435125893010"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    diesen Artikel
                </a>
                .
            </p>
        ),
    },
    {
        heading: <h3>Was ist das Zusatzpaket „Privates Profil“?</h3>,
        description: (
            <p>
                Mit dem Zusatzpaket „Privates Profil“ bleibt dein Profil trotz Verfügbarkeit oder
                Veröffentlichung unsichtbar in den Suchergebnissen und auf der Karte. Andere
                Mitglieder können nicht sehen, ob Du ihr Profil besucht oder es zu deinen Favoriten
                hinzugefügt hast. In unserem Helpcenter zeigen wir dir Schritt für Schritt, wie Du
                dieses Zusatzpaket für dein Reiter- oder Pferde-Profil aktivieren kannst. Besuche
                dazu{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/27387051412114"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    diesen Artikel
                </a>
                .
            </p>
        ),
    },
    {
        heading: <h3>Was ist das Zusatzpaket „Anonymes Profil“?</h3>,
        description: (
            <p>
                Mit dem Zusatzpaket „Anonymes Profil“ bleibt dein Name sowie der Name deines Pferdes
                für andere Mitglieder verborgen, bis Du ihre Anfrage akzeptierst. Auch Fotos und
                Videos deines Profils sind erst nach deiner Zustimmung sichtbar. Für mehr Vertrauen
                kannst Du bei proaktiven Anfragen entscheiden, die Anonymität optional aufzuheben.
                In unserem Helpcenter zeigen wir dir Schritt für Schritt, wie Du dieses Zusatzpaket
                für dein Reiter-oder Pferde-Profil aktivieren kannst. Besuche dazu{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/27387130476050"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    diesen Artikel
                </a>
                .
            </p>
        ),
    },
    {
        heading: <h3>Was ist das Zusatzpaket „Social Boost“?</h3>,
        description: (
            <p>
                Mit dem Zusatzpaket „Social Boost“ wird dein Profil aktiv auf Social Media im
                Umkreis von 15 km um deine Wohn- oder Stalladresse beworben. So erhältst Du deutlich
                mehr Sichtbarkeit bei passenden Reiter:innen und Pferdebesitzer:innen in deiner
                Nähe. In unserem Helpcenter zeigen wir dir Schritt für Schritt, wie Du dieses
                Zusatzpaket für dein Reiter- oder Pferde-Profil aktivieren kannst. Besuche dazu{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/27387135344274"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    diesen Artikel
                </a>
                .
            </p>
        ),
    },
];
